<template>
  <div class="notices-wrap" style="background-color: #ff6500; font-family: '微软雅黑';width: 100vw; height: 100vh">
    <div class="notices">
      <h1 style="font-weight: bolder">{{noticeTitle || ""}}</h1>
      <p class="notices-cont">
        {{noticeContent}}
      </p>
      <div class="notices-foot">
        <p>{{title}}运营部</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      title: sessionStorage.getItem("title"),
      noticeTitle: sessionStorage.getItem("noticeTitle"),
      noticeContent: sessionStorage.getItem("noticeContent"),
    }
  },
  created(){
    window.sessionStorage.removeItem("access_token")
    // sessionStorage.clear()
  }
};
</script>

<style scoped>
@charset "utf-8";

* {
  margin: 0;
  padding: 0;
}
body,
html {
  width: 100%;
  height: 100%;
}
body {
  background: #ff6500;
  font-family: "微软雅黑";
}
.notices-wrap {
  padding-top: 30px;
}
.notices-wrap .notices {
  position: relative;
  margin: 0 auto;
  width: 682px;
  height: 633px;
  background: url(../assets/images/404.png) no-repeat;
}
.notices h1 {
  padding-top: 225px;
  font-size: 36px;
  color: #333;
  text-align: center;
}
.notices > p {
  margin: 0 62px;
  font-size: 18px;
  color: #666;
  text-indent: 36px;
  line-height: 40px;
}
p span {
  color: #ff6500;
}
.notices .notices-cont {
  margin-top: 45px;
}
.notices .notices-tel {
  padding-bottom: 54px;
  border-bottom: 2px solid #f2f2f2;
}
.notices-foot {
  /* margin-top: 24px; */
  position: absolute;
  bottom: 50px;
  right: 50px;
}
.notices-foot p {
  font-size: 18px;
  color: #666;
  text-align: center;
}
</style>